import { render } from "./editcustomeropti.vue?vue&type=template&id=caf79daa"
import script from "./editcustomeropti.vue?vue&type=script&lang=js"
export * from "./editcustomeropti.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__